import { AppProvider } from "@shopify/polaris";
import enTranslations from "@shopify/polaris/locales/en.json";
import jaTranslations from "@shopify/polaris/locales/ja.json";
import { useSyncExternalStore, type ReactNode } from "react";

import { currentLocale, subscribeLocale } from "../lib/i18n";

/** アプリ本文と Polaris の補助表示に同じ言語を適用する。 */
export function LocaleProvider({ children }: { children: ReactNode }) {
  const locale = useSyncExternalStore(subscribeLocale, currentLocale);
  return <AppProvider i18n={locale === "en" ? enTranslations : jaTranslations}>{children}</AppProvider>;
}
